// extracted by mini-css-extract-plugin
export default {"feedback-wrapper":"configurator-web-feedback-wrapper","feedback-icon":"configurator-web-feedback-icon"};